import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ApiGo from '../../../actions/ApiGo';
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from '../../../stores/reducer_add';
import PopConfirm from '../../popUp/PopConfirm';
import AddPageFrameADMIN from './AddPageFrameADMIN';
import AuditTrail from './AuditTrail';
import UserInfo from './UserInfo';
import { ADD_USERS_ARRAY } from '../../../stores/reducer_usersArray';

const UserMainPage =(props)=>{
    const {t, i18n} = useTranslation()
    const row_header = [
        t("GLOBAL.NAME"), 
        t("ADMIN.CONNECTION_HIS_PAGE.ROLE"), 
        t("ADMIN.CONNECTION_HIS_PAGE.EMAIL"), 
        t("ADMIN.CONNECTION_HIS_PAGE.CREATED_TIME"), 
        t("ADMIN.CONNECTION_HIS_PAGE.INFORMATION"), 
        t("ADMIN.NETWORK_SETTING.CONFIG")
    ]
    const [superdoctorRow, setSuperdoctorRow] = useState([]);
    const [doctorRow, setDoctorRow] = useState([]);
    const [adminRow, setAdminRow] = useState([]);
    const [userData, setUserData] = useState(null);
    const [addUserBtn, setAddUserBtn] = useState(false);
    function toggleAddUsers(){ setAddUserBtn(!addUserBtn) }
    const [add_or_change, setAdd_or_change] = useState(["add", null]);
    const dispatch = useDispatch()
    const store_users_array = useSelector(state => state.store_users.users_array_with_superdoctor)

    // pop 確認視窗
    const [pop, setPop] = useState({
        open:false,
        content:"",
        parameter:[]
    });
    function togglePop(){
        setPop({
            open:false,
            content:"",
            parameter:[]
        })
    }
    // pop 確認視窗


    useEffect(() => {
        let [_doc, _sup, _adm] = [[],[],[]]
        store_users_array.forEach(res=>{
            if(res.role === "superdoctor"){ _sup.push(res) }
            else if(res.role === "doctor"){ _doc.push(res)}
            else if(res.role === "admin"){ _adm.push(res)}
        })
        setSuperdoctorRow(_sup)
        setDoctorRow(_doc)
        setAdminRow(_adm)    
    }, [store_users_array]); 

    function deleteUser(user){
        ApiGo.deleteUser(user.email, user.role)
        .then(res=>{
            dispatch(ADD_RESPONSE({status:200, statusText:"success", type:"delete_user"}))
            ApiGo.getUsers()
            .then(res=>{
                dispatch(ADD_USERS_ARRAY(res.users))
            })
            .catch(err=>{}) 
        })
        .catch(err=>{
            dispatch(ADD_RESPONSE({status:err.status, statusText:err.statusText, type:"delete_user"})) 
            return err.response
        })
        .then(res=>{ dispatch(ADD_RESPONSE_JSON(res)) })
    }
    function handleRole(_role){
        switch (_role) {
            case "superdoctor": return t("GLOBAL.SUPERDOCTOR");
            case "doctor": return t("GLOBAL.DOCTOR");
            case "admin": return  t("GLOBAL.ADMIN");
            default:
                break;
        }
    }
    function splitTime(_t){
        let _date = _t.split("T")
        let _time = _date[1].split(".")[0]
        return _date[0]+ " "+_time
    }


    //  ------ audit trail ------
    const [auditTrailData, setAuditTrailData] = useState("");
    const [auditTrailbtn, setAuditTrailbtn] = useState(false);
    function AuditTrailToggle(){ setAuditTrailbtn(!auditTrailbtn) }
    function getAuditTrial(_user){
        AuditTrailToggle()
        setAuditTrailData(_user)
    }
    //  ------ audit trail ------


    let [superDiv, adminDiv, doctorDiv] = [superdoctorRow, adminRow, doctorRow].map((row, index)=><div className='fx-d-c bgC-white wid-admin-90 hig-auto br-20 shadow-s-noHover pad-15 t b margb-xxs' key={index}>
        <div className='w-100 fx-d-r fx-cspar'>{row_header.map((res, index)=>
            <div className={`${index===0 || index===1? "w-10":"w-20"} fx-ccc h-100 font-ml`} key={index}>{res}
        </div>)}</div>
        {row.map(user=><div className='w-100 font-ml fx-d-r fx-cspar pad-15 t b row_hover' key={user.email}>
            <div className='w-10 fx-ccc'>
                {(i18n.language==="en")? <>
                    <div>{user.first_name}</div>
                    <div>{user.last_name}</div>
                </>
                :<>
                    <div>{user.last_name}</div>
                    <div>{user.first_name}</div>
                </>
                }    
            </div>
            <div className='w-10 fx-ccc'>{handleRole(user.role)}</div>
            <div className="w-20 fx-ccc">{user.email}</div>
            <div className="w-20 fx-ccc">{splitTime(user.created_at)}</div>
            <div className='w-20 fx-ccc'>
                <div className='bgC-light br-5 pad-15 l r shadow-xs cursor pt' 
                    onClick={()=>{getAuditTrial(user)}}>{t("AUDIT_TRAIL.AUDIT_TRAIL")}</div>
                    <div className='bgC-light-green br-5 pad-15 l r shadow-xs cursor pt margl-xs' 
                    onClick={()=>{InfoToggle(user)}}>{t("RESIDENTS_SETTING.PERSONAL_INFO")}</div>
            </div>
            <div className=' w-20 fx-ccc'>
                <div onClick={()=>{toggleAddUsers(); setAdd_or_change(["change", user])}} className='bgC-alert-E br-5 pad-15 l r shadow-xs cursor pt'>{t("RESIDENTS.EDIT")}</div>
                <div onClick={()=>{
                     setPop({
                        open:true,
                        content:t("POP_UP.Delete_user_confirm")+user.last_name+user.first_name + " ? ",
                        parameter:[user]
                    })
                }} className='bgC-alert-EE br-5 pad-15 l r shadow-xs cursor pt margl-xs'>{t("RESIDENTS.DELETE")}</div>
            </div>
        </div>)}
    </div>)

    //  ------ info ------
    const [infoBtn, setInfoBtn] = useState(false);
    function InfoToggle(_user){ 
        setUserData(_user); 
        setInfoBtn(!infoBtn)
    }
    //  ------ info ------
    return(
        <div className='w-100 h-100 fx-d-c'>
            {pop.open? 
                <PopConfirm 
                    title={t("POP_UP.Delete_user_title")}
                    content={pop.content}
                    hide={togglePop}
                    callBack={deleteUser}
                    parameter={pop.parameter}
                    />
                :null
            }
            <div className='w-20 font-l fx-d-r margb-xxs'>
                <div className='margr-s'>{t("GLOBAL.ADD_USERS")}</div>
                <div onClick={()=>{toggleAddUsers(); setAdd_or_change(["add", null])}} className='w-10 bgC-alert-E br-10 fx-ccc shadow-xs pad-45 l r'>+</div>
            </div>
            {addUserBtn? <AddPageFrameADMIN hide={toggleAddUsers} type={add_or_change}/>:null}
            {auditTrailbtn? <AuditTrail hide={AuditTrailToggle} data={auditTrailData}/>:null}
            {infoBtn? <UserInfo hide={InfoToggle} data={userData}/>:null}

            <div className='font-l'>{t("GLOBAL.ADMIN")}</div>
            {adminDiv}
            <div className='font-l'>{t("GLOBAL.SUPERDOCTOR")}</div>
            {superDiv}
            <div className='font-l'>{t("GLOBAL.DOCTOR")}</div>
            {doctorDiv}
        </div>
    );	

}
export default UserMainPage;